// Default App Theme Schema
export const DefaultConfigFile = {
  name: "elisyan",
  light: {
    colorSchema: {
      logo: {
        secondary: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/elisyan/logo/secondary-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/elisyan/logo/secondary-logo-dark.svg',
          style: {
            width: 150,
            height: 35
          },
        },
        primary: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/elisyan/logo/primary-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/elisyan/logo/primary-logo-dark.svg',
          style: {
            width: 150,
            height: 35
          },
        },
        main: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/elisyan/logo/main-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/elisyan/logo/main-logo-dark.svg',
          style: {
            width: 75,
            height: 75
          },
        },
      },
      inputs: {
        secondary: {
          background: "#F6F6F6",
          text: "#720F83",
          outline: "#720F83",
          icon: "#720F83",
        },
        plus: {
          background: ["#1D3AAB", "#880098"],
          text: "#FFFFFF",
          outline: "transparent",
          icon: "#FFFFFF",
        },
        primary: {
          background: ["#FFFFFF", "#FFFFFF"],
          text: "#00000",
          outline: "#880098",
          icon: "#FFFFFF",
        },
      },
      buttons: {
        secondary: {
          background: "#FFFFFF",
          text: "#777777",
          outline: "#777777",
          icon: "#720F83",
        },
        plus: {
          background: ["#1D3AAB", "#880098"],
          text: "#FFFFFF",
          outline: "transparent",
          icon: "#FFFFFF",
        },
        primary: {
          background: ["#1D3AAB", "#880098"],
          text: "#FFFFFF",
          outline: "transparent",
          icon: "#FFFFFF",
        },
      },
      colors: {
        secondary: "#720F83",
        progressBarDashboard: ["#1D3AAB", "#880098"],
        secondaryBackground: "#F6F6F6",
        mainBackground: "#FFFFFF",
        profilePictureStroke: "#FFFFFF",
        text: "#720F83",
        mainText: "#000000",
        primary: "#720F83",
        thirdText: "#880098",
        secondaryText: "#720F83",
        inputBackground: "#FFFFFF",
        thirdBackground: "#E7E6E6",
      },
      background: {
        profileMain: {
          dark:
          "https://themes.elisyanwealth.com/admin-dashboard/elisyan/background/dashboard-background.svg", 
          light:
          "https://themes.elisyanwealth.com/admin-dashboard/elisyan/background/dashboard-background.svg",
          style: {
            width: 0.15,
          },
        }
      } 
    },
  },
  dark: {
    colorSchema: {
      logo: {
        secondary: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/elisyan/logo/secondary-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/elisyan/logo/secondary-logo-dark.svg',
          style: {
            width: 150,
            height: 35
          },
        },
        primary: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/elisyan/logo/primary-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/elisyan/logo/primary-logo-dark.svg',
          style: {
            width: 150,
            height: 35
          },
        },
        main: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/elisyan/logo/main-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/elisyan/logo/main-logo-dark.svg',
          style: {
            width: 75,
            height: 75
          },
        },
      },
      inputs: {
        secondary: {
          background: "#F6F6F6",
          text: "#720F83",
          outline: "#720F83",
          icon: "#720F83",
        },
        plus: {
          background: ["#1D3AAB", "#880098"],
          text: "#FFFFFF",
          outline: "transparent",
          icon: "#FFFFFF",
        },
        primary: {
          background: ["#FFFFFF", "#FFFFFF"],
          text: "#720F83",
          outline: "#880098",
          icon: "#FFFFFF",
        },
      },
      buttons: {
        secondary: {
          background: "#F6F6F6",
          text: "#720F83",
          outline: "#720F83",
          icon: "#720F83",
        },
        plus: {
          background: ["#1D3AAB", "#880098"],
          text: "#FFFFFF",
          outline: "transparent",
          icon: "#FFFFFF",
        },
        primary: {
          background: ["#1D3AAB", "#880098"],
          text: "#FFFFFF",
          outline: "transparent",
          icon: "#FFFFFF",
        },
      },
      colors: {
        secondary: "#720F83",
        progressBarDashboard: ["#1D3AAB", "#880098"],
        secondaryBackground: "#061139",
        mainBackground: "#061139",
        profilePictureStroke: "#FFFFFF",
        text: "#FFFFFF",
        mainText: "#FFFFFF",
        secondaryText: "#C24AD7",
        thirdText: "#880098",
        primary: "#720F83",
        inputBackground: "#FFFFFF",
        thirdBackground: "#E7E6E6",
      },
      background: {
        profileMain: {
          dark:
          "https://themes.elisyanwealth.com/admin-dashboard/elisyan/background/dashboard-background.svg", 
          light:
          "https://themes.elisyanwealth.com/admin-dashboard/elisyan/background/dashboard-background.svg",
          style: {
            width: 0.15,
          },
        }
      } 
    },
  },
  text:{
    en:{
      welcomeScreen: "The First Private by Design Global Finance App",
      signupScreen: "Take Back the Control of your Wealth",
      loginScreen: "Welcome to Elisyan Wealth",
      loginScreenRegister: "New to Elisyan Wealth?",
      welcomeModal: "Take back the control of your wealth",
    },
    fr:{
      welcomeScreen: "La première application financière privée par design",
      signupScreen: "Reprenez le contrôle de votre richesse",
      loginScreen: "Bienvenue chez Elisyan Wealth",
      loginScreenRegister: "Nouveau chez Elisyan Wealth ?",
      welcomeModal: "Reprenez le contrôle de votre richesse",
    }
  }
};
